import CustomImage, { CustomCdnImage } from "components/common/CustomImage";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useLoadingContext } from "context/LoadingLayout";


interface GuidesObj {
    model?: string,
    changeModel: (model: string) => void,
    isGuideModal : boolean,
    currentGuideIndex: number,
    currentElementId ?: string
}
export const GuidesContext = createContext<GuidesObj|null>(null);

export function useGuidesContext() : GuidesObj | null{
    return useContext(GuidesContext);
}

export default function GuidesLayout(props: { children : ReactNode}){

    const loadingContext = useLoadingContext();

    const [ isShowEditorQuick, setIsShowEditorQuick ] = useState<boolean>(false);
    const [ isGuideModal, setIsGuideModal ]= useState<boolean>(false);
    const [ model, setModel ] = useState<string>();
    const [ currentGuideIndex, setCurrentGuideIndex] = useState<number>(0);
    const [ guide, setGuide ] = useState<GuideItem[]>();
    const [ guideItem ,setGuideItem] = useState<GuideItem>();
    const [ editorPostion, setEditorPosition] = useState<GuidePostion>();

    useEffect(() => {
        if(!loadingContext?.isLoadingLayout){
            const _hash = window.location.hash ;
            if(_hash){
                const _model = _hash.substring(1)
                const _key = 'GUIDE_QUICK_' + _model + '_finish';
                if(!localStorage.getItem(_key)){
                    changeModel(_model)
                }
            }
        }
      }, [ loadingContext?.isLoadingLayout ]);

    useEffect(() => {
        if(!localStorage.getItem('GUIDE_QUICK')){
            setIsShowEditorQuick(true);
            const _editorPosition = document.getElementById('mockupEditorScope')?.getBoundingClientRect();
            if(_editorPosition){
                setEditorPosition({ 
                    left: _editorPosition.width / 2 + _editorPosition.left, 
                    top: _editorPosition.height / 2 + _editorPosition.top, 
                    originLeft: _editorPosition.left,
                    originTop: _editorPosition.top,
                    width: _editorPosition?.width, 
                    height : _editorPosition?.height
                })
            }
        }
    },[])

    useEffect(() => {
        if(model){
            const _editorPosition = document.getElementById('mockupEditorScope')?.getBoundingClientRect();
            if(_editorPosition){
                setEditorPosition({ 
                    left: _editorPosition.width / 2 + _editorPosition.left, 
                    top: _editorPosition.height / 2 + _editorPosition.top, 
                    originLeft: _editorPosition.left,
                    originTop: _editorPosition.top,
                    width: _editorPosition?.width, 
                    height : _editorPosition?.height
                })
            }
        }
    },[model])


    useEffect(() => {
        if(model){
            const _guide = Guides[model]
            if(!_guide) return ;
            const guideItem = _guide[currentGuideIndex];
            
            const elementPosition = document.getElementById(guideItem.elementId)?.getBoundingClientRect() || {
                left: 0, top:0, width:0, height: 0
            };
            const {left, top, width, height} = elementPosition ;
            let position : GuidePostion = {...guideItem.position},
                arrowPosition : GuidePostion = { };
            if(guideItem.direction === 'right'){
                position.left = position.left || (left + width + 10);
                position.top = position.top || top ;

                arrowPosition.left = -5;
                arrowPosition.top = 25;
            }else if(guideItem.direction === 'left'){
                position.left = position.left || (left -40);
                position.top = position.top || top ;

                arrowPosition.right = -5;
                arrowPosition.top = '50%';
                arrowPosition.translateY = '-50%' ;
            }else if(guideItem.direction === 'bottom'){
                position.left = position.left || ( left + width / 2 );
                position.top = position.top || (top + height + 10) ;
                position.translateX = '-50%' ;

                arrowPosition.left = '50%';
                arrowPosition.top = -5;
            }else if(guideItem.direction === 'top'){
                position.left = position.left ||left;
                position.top = position.top || (top - 20) ;

                arrowPosition.left = width / 2;
                arrowPosition.top = -5;
            }else if(guideItem.direction === 'center'){
                if(position.right === undefined) position.left = position.left || editorPostion?.left || 0
                position.top =  position.top || editorPostion?.top || 0 ;

                arrowPosition.right = -5;
                arrowPosition.top = '50%';
                arrowPosition.translateY = '-50%' ;
            }

            // if(guideItem.isShowImage){
            // }

            guideItem.position = position || {};
            guideItem.arrowPosition = arrowPosition || {};
            // console.info(guideItem)
            setGuide(_guide)
            setGuideItem({...guideItem});
        }
    }, [model, currentGuideIndex])

    const changeModel = (model: string) => {
        if(!Guides[model]) return ;
        setIsGuideModal(true);
        setCurrentGuideIndex(0);
        setModel(model)
    }

    const next = () => {
        if(currentGuideIndex + 1 === guide?.length){
            return finish(false);
        } 
        setCurrentGuideIndex(currentGuideIndex + 1)
    }

    const finish = (isSkip: boolean) => {
        const _model = isSkip ? 'skip' : 'finish';
        const _key = 'GUIDE_QUICK_' + model + '_finish';
        if(!localStorage.getItem(_key)){
            setCurrentGuideIndex(0)
            setModel(_model);
            // if(_model === 'finish'){
                localStorage.setItem(_key, "1")
            // }
        }else{
            end();
        }
        setIsGuideModal(false);
        setIsShowEditorQuick(false);
        localStorage.setItem('GUIDE_QUICK', "1")
    }

    const end = () => {
        setModel(undefined)
        setGuide(undefined);
        setGuideItem(undefined);
    }

    const hide = () => {
        setIsShowEditorQuick(false);
        localStorage.setItem('GUIDE_QUICK', "1")
    }


    return (
        <GuidesContext.Provider value={{
            model, changeModel, isGuideModal, currentGuideIndex, currentElementId: guideItem?.elementId
        }}>
            { props.children }
            {
                isShowEditorQuick && 
                <div className="absolute w-[60%] left-[50%] translate-x-[-50%] top-[90px] rounded-[15px] bg-[#FFFFFF] p-[20px]" style={{
                    width: editorPostion?.width ? editorPostion.width - 680 : '60%',
                    maxWidth: 1000,
                    marginLeft : editorPostion?.originLeft ? (+editorPostion.originLeft + 320 - 260) / 2 : 0
                }}>
                    <CustomImage src="/icon/icon-close.png" className="absolute right-[20px] top-[20px] w-[20px] h-[20px] cursor-pointer" 
                        onClick={hide}/>
                    <p className="text-center text-[16px] font-[500]">What do you want to do now?</p>
                    <div className="mt-[20px] flex gap-[15px]">
                        <div className="border rounded-[10px] cursor-pointer hover:border-[#14A5FA]" onClick={() => changeModel('mockup')}>
                            <CustomCdnImage src="/editor/guide/guide-mockup.webp" className="w-full rounded-t-[10px]"/>
                            <div className="py-[10px] px-[15px]">
                                <p className="small-txt font-[500]">Generate Mockups</p>
                                <span className="mt-[5px] sosmall-txt">Any image into an editable mockup.</span>
                            </div>
                        </div>
                        <div className="border rounded-[10px] cursor-pointer hover:border-[#14A5FA]" onClick={() => changeModel('template')}>
                            <CustomCdnImage src="/editor/guide/guide-template.webp" className="w-full rounded-t-[10px]"/>
                            <div className="py-[10px] px-[15px]">
                                <p className="small-txt font-[500]">Use Mockup Templates</p>
                                <span className="mt-[5px] sosmall-txt">Ready-to-use mockup templates.</span>
                            </div>
                        </div>
                        <div className="border rounded-[10px] cursor-pointer hover:border-[#14A5FA]" onClick={() => changeModel('color')}>
                            <CustomCdnImage src="/editor/guide/guide-color.webp" className="w-full rounded-t-[10px]"/>
                            <div className="py-[10px] px-[15px]">
                                <p className="small-txt font-[500]">Change Product Colors</p>
                                <span className="mt-[5px] sosmall-txt">Quickly change any product color.</span>
                            </div>
                        </div>
                        <div className="border rounded-[10px] cursor-pointer hover:border-[#14A5FA]" onClick={() => changeModel('aop')}>
                            <CustomCdnImage src="/editor/guide/guide-aop.webp" className="w-full rounded-t-[10px]"/>
                            <div className="py-[10px] px-[15px]">
                                <p className="small-txt font-[500]">AOP Design</p>
                                <span className="mt-[5px] sosmall-txt">Design All-Over-Prints (AOP).</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                guide && guideItem && 
                <>
                    {
                        guide?.length > 1 && 
                        <>
                            <div className="fixed bg-[#EFF3F5] z-[9999]" style={{
                                left: editorPostion?.originLeft,
                                top: editorPostion?.originTop,
                                width: editorPostion?.width,
                                height: editorPostion?.height
                            }}></div>
                            <div className="fixed z-[9999998] left-0 top-0 w-full h-full"></div>

                            <div className="fixed z-[9999999] left-0 bottom-[50px] w-full  flex items-center justify-center">
                                <div className="px-[15px] py-[10px] bg-[#F0B43A]/[0.2] rounded-[10px] flex gap-[10px] items-center">
                                    <CustomImage src="/icon/icon-warning.png" className="w-[20px] h-[20px]"/>
                                    <div className="text-[#DA9E25] text-[12px]">
                                        <p>This guide is intended as a functional demonstration only. </p>
                                        <p>You can quickly understand how to use the features and get started with actual operations.</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    
                    <div className={`absolute max-w-[360px] p-[20px] rounded-[20px] bg-[#4986FF] text-[#FFFFFF] z-[99999999] ${guide?.length == 1 ? 'transition-[left,top,right]' : ''}`}
                        style={{
                            top: guideItem.position?.top,
                            ...(
                                guideItem.position && guideItem.position.left !== undefined ? 
                                {left: guideItem.position?.left} : 
                                {right: guideItem.position?.right}
                            ),
                            ...(guideItem.position?.translateX || guideItem.position?.translateY
                                ? {transform : `translate(${guideItem.position?.translateX || 0}, ${guideItem.position?.translateY || 0})`} : {}),
                        }}>
                        <span className="medium-txt font-bold">{guideItem?.title}</span>
                        <>
                            {
                                guideItem.desc.map((c: string, i: number) => (
                                    <p key={i} className="mt-[10px] small-txt">{c}</p>
                                ))
                            }
                        </>
                        {
                            guide?.length > 1 ?
                            <div className="flex items-center mt-[20px]">
                                <span>{currentGuideIndex + 1}/{guide?.length}</span>
                                <div className="grow text-right " >
                                    {
                                        guide && currentGuideIndex + 1 < guide.length && <span className=" cursor-pointer" onClick={() => finish(true)}>Skip</span>
                                    }
                                </div>
                                <span className="px-[20px] py-[5px] bg-[#9ABCFF] rounded-[20px] ml-[10px] cursor-pointer"
                                    onClick={next}>{currentGuideIndex + 1 == guide?.length ? 'Got it!' : 'Next'}</span>
                            </div>
                            :
                            <div className="flex items-end mt-[20px]">
                                <div className="grow text-right " ></div>
                                <span className="px-[20px] py-[5px] bg-[#9ABCFF] rounded-[20px] ml-[10px] cursor-pointer"
                                    onClick={end}>OK</span>
                            </div>
                        }
                        
                        {
                            <div className={`absolute w-[15px] h-[15px] bg-[#4986FF] ${guideItem.direction === 'bottom' || guideItem.direction === 'top' 
                                    ? 'rotate-[58deg] skew-x-[30deg] translate-x-[-50%]' 
                                    : 'rotate-[123deg] skew-y-[30deg]'}  ${guideItem.arrowPosition?.translateY ? 'translate-y-[-50%]' : ''}`}
                                style={{
                                    ...(
                                        guideItem.arrowPosition?.left === undefined ?
                                        {right: guideItem.arrowPosition?.right}:
                                        {left: guideItem.arrowPosition?.left}
                                    ),
                                    ...(
                                        guideItem.direction === 'top'  ?
                                        {bottom: guideItem.arrowPosition?.top}:
                                        {top: guideItem.arrowPosition?.top}
                                    ),
                                    // top: guideItem.arrowPosition?.top,
                                }}>
                            </div>
                        }
                    </div>
                    {
                        editorPostion && 
                            guide.map((item: GuideItem, index: number) => (
                                <CustomCdnImage key={index} src={item.imageUrl} className="absolute translate-x-[-50%] translate-y-[-50%] z-[10000] transition-opacity duration-[200ms]"
                                    style={{
                                        opacity: index === currentGuideIndex ? 1 : 0,
                                        left: editorPostion.left,
                                        top: editorPostion.top,
                                        height: (editorPostion.height || 100) * 0.8
                                    }} />
                            ))
                    }
                    
                </>
            }
        </GuidesContext.Provider>
    )
}


type GuidePostion = {
    left ?: number | string,
    right ?: number | string,
    top ?: number | string,
    originLeft ?: number,
    originTop ?: number,
    width ?: number,
    height ?: number
    translateX ?: string,
    translateY ?: string,
}

type GuideItem = {
    elementId: string,
    title: string,
    desc : string[],
    direction : string,
    isShowImage ?: boolean,
    imageUrl ?: string,
    position ?: GuidePostion,
    arrowPosition ?: GuidePostion,
    imagePosition ?: GuidePostion
}


interface Guide {
    [key: string] : GuideItem[]
}

const Guides : Guide = {
    'mockup' : [{
            elementId: 'step1_element',
            title:'Upload product image',
            desc: ['First click to upload the product image as the basis for generating the mockup.'],
            direction: 'right'
        },{
            elementId: 'step2_element',
            title:'Generate mockup',
            desc: ['Click the "Mockup" button to generate the selected product image into a mockup image.'],
            isShowImage: true,
            imageUrl: '/editor/guide/mockup-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step1_element',
            title:'Upload design image',
            desc: ['Click to upload the design image that needs to be placed on the mockup.'],
            isShowImage: true,
            imageUrl: '/editor/guide/mockup-2.webp',
            direction: 'right'
        },{
            elementId: 'mockupEditorScope',
            title:'Drag design image onto the mockup',
            desc: ['After dragging the design pattern in, it will automatically realize the stretch fit to achieve the 3D fitting effect.'],
            isShowImage: true,
            imageUrl: '/editor/guide/mockup-3.webp',
            direction: 'center',
            position : { right: '35%', translateX: '-50%', translateY: '-50%'}
        },{
            elementId: 'step5_element',
            title:'Download',
            desc: ['Click to “Download” your designed mockup (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/mockup-4.webp',
            direction: 'bottom'
        }],
    'template' : [{
            elementId: 'step1_element',
            title:'Choose a Mockup',
            desc: ['Select a mockup template. It will automatically appear on your canvas.'],
            direction: 'right',
            position: {left: 420, top: '20%'}
        },{
            elementId: 'step1_element',
            title:'Select a Pattern',
            desc: ['Choose a design from the Pattern templates or upload your own to instantly apply it to your mockup.'],
            isShowImage: true,
            imageUrl: '/editor/guide/template-1.webp',
            direction: 'right',
            position: {left: 420, top: '20%'}
        },{
            elementId: 'mockupEditorScope',
            title:'Drag design image onto the mockup',
            desc: ['After dragging the design pattern in, it will automatically realize the stretch fit to achieve the 3D fitting effect.'],
            isShowImage: true,
            imageUrl: '/editor/guide/template-2.webp',
            direction: 'center',
            position : { right: '50%', translateY: '-50%'}
        },{
            elementId: 'step5_element',
            title:'Download',
            desc: ['Click to “Download” your designed mockup (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/template-3.webp',
            direction: 'bottom'
        }],
    'color' : [{
            elementId: 'step1_element',
            title:'Upload product image',
            desc: ['First, click to upload the product image you want to modify the colour of.'],
            direction: 'right'
        },{
            elementId: 'step_color_element',
            title:'Select Color Tool',
            desc: ['Click the “Color” button to enter color replacement mode.'],
            isShowImage: true,
            imageUrl: '/editor/guide/color-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step_setting_element',
            title:'Pinpoint and Change',
            desc: ['Click on a specific area, or use the brush to precisely select and fine-tune your target area. Choose a new color, then click Save.'],
            isShowImage: true,
            imageUrl: '/editor/guide/color-2.webp',
            direction: 'left',
            position : {top: '32%', translateX: '-100%'}
        },{
            elementId: 'step5_element',
            title:'Download',
            desc: ['Click to “Download” your image (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.', 'Or use it right away in your current project.'],
            isShowImage: true,
            imageUrl: '/editor/guide/color-3.webp',
            direction: 'bottom'
        }],
    'aop' : [{
            elementId: 'step1_element',
            title:'Upload image',
            desc: ['Start by uploading your product photo and your design pattern.'],
            direction: 'right'
        },{
            elementId: 'step2_element',
            title:'Generate mockup',
            desc: ['Select your product photo and click the “Mockup” button to turn it into a mockup.'],
            isShowImage: true,
            imageUrl: '/editor/guide/aop-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step_area_element',
            title:'Generate mockup',
            desc: ['Click the “Area Select” button on your new mockup to define where the pattern will be displayed. You can use the brush to fine-tune the area, then Save.'],
            isShowImage: true,
            imageUrl: '/editor/guide/aop-2.webp',
            direction: 'bottom'
        },{
            elementId: 'step_setting_element',
            title:'Drag & Customize',
            desc: ['Drag your design onto the mockup. Use the Pattern Type panel to select a layout, and then scale or rotate the design to your liking.'],
            isShowImage: true,
            imageUrl: '/editor/guide/aop-3.webp',
            direction: 'left',
            position : {top: '30%', translateX: '-100%'}
        },{
            elementId: 'step5_element',
            title:'Download',
            desc: ['Click to “Download” your designed mockup (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/aop-4.webp',
            direction: 'bottom'
        }],
    'text' : [{
            elementId: 'step1_element',
            title:'Upload product image',
            desc: ['First click to upload the product image as the basis for generating the mockup.'],
            direction: 'right'
        },{
            elementId: 'step2_element',
            title:'Generate mockup',
            desc: ['Click the "Mockup" button to generate the selected product image into a mockup image.'],
            isShowImage: true,
            imageUrl: '/editor/guide/text-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step_text3_element',
            title:'Add Your Text',
            desc: ['Click the “Text” button, then click on the canvas to type. Use the text panel to style your font.'],
            isShowImage: true,
            imageUrl: '/editor/guide/text-2.webp',
            direction: 'right',
            position: {left: 420, top: '25%'}
        },{
            elementId: 'step_text_element',
            title:'Convert to Vector',
            desc: ['Select your text and click “Flatten Text” to turn it into a vector image.'],
            isShowImage: true,
            imageUrl: '/editor/guide/text-3.webp',
            direction: 'bottom'
        },{
            elementId: 'mockupEditorScope',
            title:'Apply to Mockup',
            desc: ['Drag the new vector image onto your mockup. It will automatically adjust to the shape, and you can freely scale or rotate it.'],
            isShowImage: true,
            imageUrl: '/editor/guide/text-4.webp',
            direction: 'center',
            position : { right: '50%', translateY: '-50%'}
        },{
            elementId: 'step5_element',
            title:'Download',
            desc: ['Click to “Download” your designed mockup (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/text-5.webp',
            direction: 'bottom'
        }],
    'rasterize' : [{
            elementId: 'step_rasterize_element',
            title:'Rasterize Mockup',
            desc: ['Click Rasterize to convert your mockup into a vector image.'],
            isShowImage: true,
            imageUrl: '/editor/guide/rasterize-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step_color_element',
            title:'Recolor',
            desc: ['Once rasterized, you can easily change the image\'s color and then turn it back into a mockup for more design options.'],
            isShowImage: true,
            imageUrl: '/editor/guide/rasterize-2.webp',
            direction: 'bottom'
        },{
            elementId: 'step_removebg_element',
            title:'Use AI Tools',
            desc: ['Use our AI tools to edit the new vector image, then download your final creation.'],
            isShowImage: true,
            imageUrl: '/editor/guide/rasterize-3.webp',
            direction: 'bottom'
        }],
    'removebg' : [{
            elementId: 'step1_element',
            title:'Upload image',
            desc: ['Upload the image you need to remove the background from.'],
            direction: 'right'
        },{
            elementId: 'step_removebg_element',
            title:'One-Click Removal',
            desc: ['Click the “Remove background” button to instantly get a clean cutout.'],
            isShowImage: true,
            imageUrl: '/editor/guide/removebg-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step5_element',
            title:'Download or Design',
            desc: ['Click to “Download” your image (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.', 'Or use it right away in your current project.'],
            isShowImage: true,
            imageUrl: '/editor/guide/removebg-2.webp',
            direction: 'bottom'
        }],
    'upscale' : [{
            elementId: 'step1_element',
            title:'Upload image',
            desc: ['Upload the image you want to enhance.'],
            direction: 'right'
        },{
            elementId: 'step_upscale_element',
            title:'One-Click Enhancement',
            desc: ['Click the “Clarity” button to automatically improve your image\'s sharpness.'],
            isShowImage: true,
            imageUrl: '/editor/guide/upscale-1.webp',
            direction: 'bottom'
        },{
            elementId: 'step5_element',
            title:'Download ',
            desc: ['Click to “Download” your image (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/upscale-2.webp',
            direction: 'bottom'
        }],
    'eraser' : [{
            elementId: 'step1_element',
            title:'Upload image',
            desc: ['Upload the image you want to edit.'],
            direction: 'right'
        },{
            elementId: 'step_eraser_element',
            title:'Select Erase Tool',
            desc: ['Click the “Erase” button and choose your preferred method (Daub or Circle Select).'],
            isShowImage: true,
            imageUrl: '/editor/guide/eraser-1.webp',
            direction: 'bottom'
        },{
            elementId: 'mockupEditorScope',
            title:'Remove Objects ',
            desc: ['Manually paint over or circle the objects you want to remove, then click Confirm to erase them.'],
            isShowImage: true,
            imageUrl: '/editor/guide/eraser-2.webp',
            direction: 'center',
            position : { right: '50%', translateY: '-50%'}
        },{
            elementId: 'step5_element',
            title:'Download ',
            desc: ['Click to “Download” your image (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.'],
            isShowImage: true,
            imageUrl: '/editor/guide/eraser-3.webp',
            direction: 'bottom'
        }],
    'ai-image' : [{
            elementId: 'step1_element',
            title:'Text to Image',
            desc: ['Type your prompt, select your image size, and click “Generate” to create a new image from scratch.'],
            direction: 'right',
            position: {left: 420, top: '20%'}
        },{
            elementId: 'mockupEditorScope',
            title:'Image to Image',
            desc: ['Type your prompt, upload a reference image, select your image size, and click “Generate” to transform an existing photo.'],
            direction: 'right',
            position: {left: 420, top: '20%'}
        },{
            elementId: 'step5_element',
            title:'Download or Design ',
            desc: ['Click to “Download” your image (JPG, PNG, WEBP) and easily adjust the aspect ratio for any use.', 'Or use it right away in your current project.'],
            isShowImage: true,
            imageUrl: '/editor/guide/ai-image-1.webp',
            direction: 'bottom'
        }],
    'skip' : [{
        elementId: 'finish_element',
        title:'View guide',
        desc: ['You can click here to explore more feature guides.'],
        direction: 'top',
        position: { translateY: '-100%'}
    }],
    'finish' : [{
        elementId: 'finish_element',
        title:'You’ve completed the guide!',
        desc: ['You can click here to explore more feature guides.'],
        direction: 'top',
        position: { translateY: '-100%'}
    }]
}